export default "__VITE_ASSET__CiMkwqtQ__"